import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';

import BundleDetailSection from './bundleDetailSection';

import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import useBundleDetail from '@hooks/bundle/useBundleDetail';
import useBundleEnrollment from '@hooks/bundle/useBundleEnrollment';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleDetailProps = {
  bundleDetailSeo: BundleEntity;
};

const BundleDetail: FC<BundleDetailProps> = ({ bundleDetailSeo }) => {
  const router = useRouter();
  const bundleIdOrIdName = router?.query?.idName as string;

  const { handleFetchBundleDetail, handleResetBundleDetail } = useBundleDetail();
  const { handleResetBundleCourses } = useBundleCourseItem();
  const { handleFetchBundleEnrollment, handleResetBundleEnrollment } = useBundleEnrollment();

  useEffect(() => {
    if (!bundleIdOrIdName) {
      return;
    }

    handleFetchBundleDetail(bundleIdOrIdName);
    handleFetchBundleEnrollment(bundleIdOrIdName);

    return () => {
      handleResetBundleDetail();
      handleResetBundleCourses();
      handleResetBundleEnrollment();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bundleIdOrIdName]);

  return <BundleDetailSection bundleDetailSeo={bundleDetailSeo} />;
};

export default BundleDetail;
